/**
 * Gestion d'un store d'historique.
 * N'est utilisé que pour la redirection après l'authentification
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export const useHistoryStore = defineStore('history', (() => {

    // State de la route précédente
    // Objet avec le nom de la route et les paramètres pour une utilisation avec VueRouter
    const previous = ref(null);

    // Vrai si la position du scroll doit être préservé
    const mustPreserveScrollPosition = ref(false);

    /**
     * Retourne la route précédente
     * @return object|null
     */
    const getPrevious = computed(() => {
        return previous.value;
    });

    /**
     * Retourne si la position du scroll doit être préservée
     * @return bool
     */
    const getMustPreserveScrollPosition = computed(() => mustPreserveScrollPosition.value);

    /**
     * Modifie la route précédente
     * @param object|null route
     * @return void
     */
    const setPrevious = ((route) => {
        previous.value = route;
    });

    /**
     * Modifie si la position du scroll doit être préservée
     * @param bool preserve
     * @return void
     */
    const setMustPreserveScrollPosition = ((preserve) => {
        mustPreserveScrollPosition.value = preserve;
    });

    return {
        previous,
        getPrevious,
        setPrevious,
        getMustPreserveScrollPosition,
        setMustPreserveScrollPosition
    };
}));
